import '@mdi/font/css/materialdesignicons.css'
import Vue from 'vue';
import Vuetify from 'vuetify/lib';

Vue.use(Vuetify);

export default new Vuetify({
    theme: {
        themes: {
            light: {
                primary: '#DFB680', // #E53935
                secondary: '#DFB680', // #FFCDD2
                accent: '#B0916B', // #3F51B5
            },
        },
        dark: false
    },
})
